import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { WishlistService } from '../../providers/wishlist/wishlist.service';
import { StateService } from '../../providers/state/state.service';

@Component({
    selector: 'vsf-wishlist-toggle',
    template: `
        <button *ngIf="signedIn$ | async"
                class="text-heading relative hover:text-primary transition-colors"
                (click)="goToWishlist()"
                title="Wishlist">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
            </svg>
            <span *ngIf="(count$ | async) as count"
                  class="absolute -top-2 -right-3 bg-primary rounded-full w-5 h-5 flex items-center justify-center text-xs text-white">
                {{ count }}
            </span>
        </button>
    `,
    styles: [`:host { display: contents; }`],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistToggleComponent implements OnInit {
    count$: Observable<number>;
    signedIn$: Observable<boolean>;

    constructor(
        private wishlistService: WishlistService,
        private stateService: StateService,
        private router: Router,
    ) {}

    ngOnInit() {
        this.count$ = this.wishlistService.count$;
        this.signedIn$ = this.stateService.select(state => state.signedIn);
    }

    goToWishlist() {
        this.router.navigate(['/account', 'wishlist']);
    }
}
